// extracted by mini-css-extract-plugin
export default {"componentWrapper":"EmptyInbox_componentWrapper__YHIG1","messageButton":"EmptyInbox_messageButton__QCzaM"};